<template>
  <div class="dd-detail-overlay" @click.self="$emit('close')">
    <div class="dd-detail-dialog">
      <div class="dd-dialog-h">
        <div style="flex:1;min-width:0">
          <div class="dd-dialog-title">尽调材料详情</div>
          <div class="dd-dialog-sub">{{ applyInfo.companyName || '--' }} · 市场端尽调材料</div>
        </div>
        <button class="dd-dialog-x" title="关闭" @click="$emit('close')">✕</button>
      </div>

      <div v-if="ddData" class="dd-dialog-body">
        <!-- 经营场所核实 -->
        <div class="dd-sec">
          <div class="dd-sec-h"><span class="dd-sn">1</span>经营场所核实</div>
          <div class="dd-grid c2">
            <div><div class="dk">实际经营地址</div><div class="dv">{{ ddData.actualAddress || '--' }}</div></div>
            <div><div class="dk">场所性质</div><div class="dv">{{ ddData.locationType || '--' }}</div></div>
          </div>
          <div v-if="sitePhotos.length" class="dd-photo-sec">
            <div class="dd-photo-label">场所照片（办公照片）<span class="cnt">{{ sitePhotos.length }} 张</span></div>
            <div class="dd-photo-wall">
              <div v-for="(p, i) in sitePhotos" :key="i" class="dd-photo-thumb" @click="previewImg = p">
                <img :src="p" alt="场所照片">
                <span class="idx">{{ i + 1 }}</span>
              </div>
            </div>
          </div>
          <div v-else class="dd-empty-tip">未上传场所照片</div>
        </div>

        <!-- 历史发货信息 -->
        <div class="dd-sec">
          <div class="dd-sec-h"><span class="dd-sn">2</span>历史发货信息</div>
          <div class="dd-grid c3">
            <div><div class="dk">月均发货票数</div><div class="dv">{{ ddData.monthlyShipments || '--' }}</div></div>
            <div><div class="dk">月均发货吨位</div><div class="dv">{{ ddData.monthlyTonnage || '--' }}</div></div>
            <div><div class="dk">月均发货金额（万元）</div><div class="dv">{{ ddData.monthlyAmount || '--' }}</div></div>
          </div>
          <div v-if="contractFiles.length" class="dd-file-sec">
            <div class="dd-photo-label">历史运输合同<span class="cnt">{{ contractFiles.length }} 份</span></div>
            <div class="dd-photo-wall">
              <div v-for="(f, i) in contractFiles" :key="i" class="dd-photo-thumb" :class="{ 'is-file': !f.isImg }" @click="onOpenFile(f)">
                <img v-if="f.isImg" :src="f.url" alt="运输合同">
                <template v-else>
                  <span class="file-ico">📄</span>
                  <span class="file-name">{{ f.name }}</span>
                </template>
                <span class="idx">{{ i + 1 }}</span>
              </div>
            </div>
          </div>
          <div v-else-if="ddData.supplementaryMaterials2Img === '' || ddData.supplementaryMaterials2Img == null" class="dd-empty-tip">未上传历史运输合同</div>
          <div v-if="waybillFiles.length" class="dd-file-sec">
            <div class="dd-photo-label">近 3 月历史运单<span class="cnt">{{ waybillFiles.length }} 份</span></div>
            <div class="dd-photo-wall">
              <div v-for="(f, i) in waybillFiles" :key="i" class="dd-photo-thumb" :class="{ 'is-file': !f.isImg }" @click="onOpenFile(f)">
                <img v-if="f.isImg" :src="f.url" alt="历史运单">
                <template v-else>
                  <span class="file-ico">📄</span>
                  <span class="file-name">{{ f.name }}</span>
                </template>
                <span class="idx">{{ i + 1 }}</span>
              </div>
            </div>
          </div>
          <div v-else-if="ddData.supplementaryMaterials3Img === '' || ddData.supplementaryMaterials3Img == null" class="dd-empty-tip">未上传近 3 月历史运单</div>
        </div>

        <!-- 常发线路与货物 -->
        <div class="dd-sec">
          <div class="dd-sec-h"><span class="dd-sn">3</span>常发线路与货物</div>
          <div v-if="routeList.length" class="dd-lines">
            <span v-for="(r, i) in routeList" :key="i" class="rb">{{ r.from }} → {{ r.to }}<em>{{ r.vehicleType }} · {{ r.frequency }}</em></span>
          </div>
          <div v-else class="dd-empty-tip">未填写常发线路</div>
          <div class="dd-grid c2">
            <div><div class="dk">常发货物</div><div class="dv">{{ ddData.commonCargo || '--' }}</div></div>
            <div><div class="dk">客户所属行业</div><div class="dv">{{ ddData.industry || '--' }}</div></div>
          </div>
        </div>

        <!-- 执行费率与客户需求 -->
        <div class="dd-sec">
          <div class="dd-sec-h"><span class="dd-sn">4</span>执行费率与客户需求</div>
          <div class="dd-grid c3">
            <div><div class="dk">客户执行费率（%）</div><div class="dv">{{ ddData.feeRate || '--' }}</div></div>
            <div><div class="dk">付款周期</div><div class="dv">{{ ddData.paymentCycle || '--' }}</div></div>
            <div><div class="dk">是否有常用车队</div><div class="dv">{{ ddData.hasOwnFleet || '--' }}</div></div>
          </div>
          <div v-if="painPoints.length" class="dd-chip-sec">
            <div class="dd-photo-label">客户痛点</div>
            <div class="chip-group">
              <span v-for="(p, i) in painPoints" :key="i" class="chip on">{{ p }}</span>
            </div>
          </div>
          <div v-if="needs.length" class="dd-chip-sec">
            <div class="dd-photo-label">客户需求</div>
            <div class="chip-group">
              <span v-for="(n, i) in needs" :key="i" class="chip on">{{ n }}</span>
            </div>
          </div>
          <div v-if="ddData.serviceRemark || applyInfo.serviceRemark" class="dd-concl">
            <div class="dd-photo-label">其他说明</div>
            <div class="concl-box">{{ ddData.serviceRemark || applyInfo.serviceRemark }}</div>
          </div>
          <div v-if="ddData.ddConclusion" class="dd-concl">
            <div class="dd-photo-label">尽调结论</div>
            <div class="concl-box">{{ ddData.ddConclusion }}</div>
          </div>
        </div>
      </div>

      <div v-else class="dd-dialog-body">
        <div class="dd-empty-tip" style="padding:60px 0">尽调材料尚未提交</div>
      </div>

      <div class="dd-dialog-ft">
        <el-button size="small" @click="$emit('close')">关闭</el-button>
      </div>
    </div>

    <div v-if="previewImg" class="img-preview" @click.self="previewImg = ''">
      <button class="img-preview-x" @click="previewImg = ''">✕</button>
      <img :src="previewImg" :style="previewImgStyle" alt="大图预览">
      <div class="img-preview-toolbar">
        <button class="img-preview-tool" title="缩小" @click="previewZoomOut"><i class="el-icon-zoom-out" /></button>
        <button class="img-preview-tool" title="放大" @click="previewZoomIn"><i class="el-icon-zoom-in" /></button>
        <button class="img-preview-tool" title="自适应" @click="previewFit"><i class="el-icon-full-screen" /></button>
        <button class="img-preview-tool" title="向左旋转" @click="previewRotateLeft"><i class="el-icon-refresh-left" /></button>
        <button class="img-preview-tool" title="向右旋转" @click="previewRotateRight"><i class="el-icon-refresh-right" /></button>
      </div>
    </div>
  </div>
</template>

<script>
const IMG_RE = /\.(png|jpe?g|gif|webp|bmp)$/i;

function toFileList(str) {
  return String(str || "")
    .split(",")
    .filter(Boolean)
    .map(url => {
      let name = "附件";
      try { name = decodeURIComponent(String(url).split("/").pop() || "") || "附件"; } catch (e) { /* keep default */ }
      return { url, isImg: IMG_RE.test(url), name };
    });
}

export default {
  name: "DdDetailDialog",
  props: {
    ddData: { type: Object, default: null },
    applyInfo: { type: Object, default: () => ({}) }
  },
  data() {
    return { previewImg: "", previewRotate: 0, previewScale: 1 };
  },
  computed: {
    sitePhotos() {
      const s = (this.ddData && this.ddData.sitePhotos) || "";
      return String(s).split(",").filter(Boolean);
    },
    contractFiles() {
      return toFileList(this.ddData && this.ddData.supplementaryMaterials2Img);
    },
    waybillFiles() {
      return toFileList(this.ddData && this.ddData.supplementaryMaterials3Img);
    },
    routeList() {
      const s = (this.ddData && this.ddData.commonRoutes) || "";
      try { return JSON.parse(s) || []; } catch (e) { return []; }
    },
    painPoints() {
      const s = (this.ddData && this.ddData.customerPainPoints) || "";
      return String(s).split(",").filter(Boolean);
    },
    needs() {
      const s = (this.ddData && this.ddData.customerNeeds) || "";
      return String(s).split(",").filter(Boolean);
    },
    previewImgStyle() {
      const deg = ((this.previewRotate % 360) + 360) % 360;
      const sideways = deg === 90 || deg === 270;
      return {
        transform: `rotate(${this.previewRotate}deg) scale(${this.previewScale})`,
        maxWidth: sideways ? "88vh" : "90%",
        maxHeight: sideways ? "90%" : "88%"
      };
    }
  },
  watch: {
    previewImg() {
      this.previewRotate = 0;
      this.previewScale = 1;
    }
  },
  methods: {
    onOpenFile(f) {
      if (f.isImg) { this.previewImg = f.url; return; }
      if (f.url) window.open(f.url, "_blank");
    },
    previewZoomIn() {
      this.previewScale = Math.min(3, +(this.previewScale + 0.2).toFixed(2));
    },
    previewZoomOut() {
      this.previewScale = Math.max(0.5, +(this.previewScale - 0.2).toFixed(2));
    },
    previewFit() {
      this.previewRotate = 0;
      this.previewScale = 1;
    },
    previewRotateLeft() {
      this.previewRotate -= 90;
    },
    previewRotateRight() {
      this.previewRotate += 90;
    }
  }
};
</script>

<style lang="scss" scoped>
.dd-detail-overlay { position: fixed; inset: 0; background: rgba(15,23,42,0.45); z-index: 2100; display: flex; align-items: flex-start; justify-content: center; padding: 6vh 18px 18px; overflow-y: auto; }
.dd-detail-dialog { background: #f5f7fa; border-radius: 16px; width: 780px; max-width: 100%; box-shadow: 0 24px 64px -12px rgba(16,24,40,0.35); display: flex; flex-direction: column; max-height: 88vh; overflow: hidden; }

.dd-dialog-h { display: flex; align-items: center; gap: 12px; padding: 16px 20px; background: #fff; border-bottom: 1px solid #e2e8f0; flex-shrink: 0; }
.dd-dialog-title { font-size: 16px; font-weight: 700; }
.dd-dialog-sub { font-size: 12px; color: #64748b; margin-top: 2px; }
.dd-dialog-x { width: 30px; height: 30px; border-radius: 9px; border: 1px solid #e2e8f0; background: #fff; color: #64748b; cursor: pointer; font-size: 13px; flex-shrink: 0; display: flex; align-items: center; justify-content: center; }
.dd-dialog-x:hover { background: #f1f5f9; color: #0f172a; }

.dd-dialog-body { flex: 1; overflow-y: auto; padding: 16px 20px 20px; display: flex; flex-direction: column; gap: 14px; }
.dd-dialog-ft { flex-shrink: 0; display: flex; justify-content: flex-end; padding: 12px 20px; background: #fff; border-top: 1px solid #e2e8f0; }

.dd-sec { background: #fff; border: 1px solid #e2e8f0; border-radius: 12px; padding: 15px 18px; }
.dd-sec-h { display: flex; align-items: center; gap: 8px; font-size: 13.5px; font-weight: 700; color: #0f172a; margin-bottom: 13px; }
.dd-sn { width: 20px; height: 20px; border-radius: 50%; background: linear-gradient(135deg,#426df0,#5931cf); color: #fff; display: flex; align-items: center; justify-content: center; font-size: 11px; font-weight: 700; flex-shrink: 0; }

.dd-grid { display: grid; gap: 12px 20px; margin-bottom: 12px; }
.dd-grid.c2 { grid-template-columns: repeat(2, 1fr); }
.dd-grid.c3 { grid-template-columns: repeat(3, 1fr); }
@media (max-width: 640px) { .dd-grid.c2, .dd-grid.c3 { grid-template-columns: 1fr; } }
.dk { font-size: 11px; color: #64748b; margin-bottom: 4px; display: block; }
.dv { font-size: 13px; font-weight: 600; color: #181b20; line-height: 1.6; word-break: break-all; }

.dd-photo-label { font-size: 11.5px; font-weight: 600; color: #334155; margin-bottom: 9px; display: flex; align-items: center; gap: 8px; }
.dd-photo-label .cnt { font-size: 10.5px; color: #94a3b8; font-weight: 400; }
.dd-photo-wall { display: grid; grid-template-columns: repeat(auto-fill, minmax(110px, 1fr)); gap: 10px; margin-bottom: 4px; }
.dd-photo-thumb { position: relative; border: 1px solid #e2e8f0; border-radius: 10px; overflow: hidden; cursor: pointer; height: 82px; background: linear-gradient(135deg, #EDF1FA, #E4EAF6); transition: 0.15s; display: flex; align-items: center; justify-content: center; }
.dd-photo-thumb:hover { box-shadow: 0 8px 24px -8px rgba(16,24,40,0.2); transform: translateY(-1px); border-color: #426df0; }
.dd-photo-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }
.dd-photo-thumb .idx { position: absolute; right: 5px; top: 5px; font-size: 9.5px; color: #fff; background: rgba(15,23,42,0.55); border-radius: 5px; padding: 1px 6px; font-family: "SF Mono", "JetBrains Mono", ui-monospace, Menlo, Consolas, "Liberation Mono", monospace; }
.dd-photo-thumb .file-ico { font-size: 24px; line-height: 1; }
.dd-photo-thumb.is-file { background: #f8fafc; flex-direction: column; gap: 3px; padding: 5px; }
.dd-photo-thumb .file-name { font-size: 9.5px; color: #64748b; text-align: center; word-break: break-all; line-height: 1.3; max-height: 32px; overflow: hidden; padding: 0 3px; }

.dd-lines { display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 12px; }
.rb { border: 1px solid #e2e8f0; border-radius: 8px; padding: 6px 10px; font-size: 12px; font-weight: 600; background: #fbfcfe; }
.rb em { font-weight: 400; color: #64748b; font-size: 10px; font-style: normal; margin-left: 4px; }

.dd-chip-sec { margin-bottom: 12px; }
.chip-group { display: flex; flex-wrap: wrap; gap: 6px; }
.chip { padding: 6px 13px; border-radius: 999px; border: 1px solid rgba(66,109,240,.25); font-size: 12.5px; color: #426df0; background: rgba(66,109,240,.06); font-weight: 500; }

.dd-concl { }
.concl-box { border-left: 3px solid #426df0; background: #f7f9ff; border-radius: 0 10px 10px 0; padding: 10px 14px; font-size: 12.5px; line-height: 1.7; color: #334155; }

.dd-empty-tip { padding: 20px 0; text-align: center; color: #94a3b8; font-size: 12px; }

.img-preview { position: fixed; inset: 0; z-index: 3000; background: rgba(10,14,20,0.85); display: flex; align-items: center; justify-content: center; padding: 40px; overflow: hidden; }
.img-preview img { max-width: 90%; max-height: 88%; object-fit: contain; border-radius: 8px; box-shadow: 0 16px 60px rgba(0,0,0,0.5); background: #fff; }
.img-preview-x { position: fixed; top: 20px; right: 24px; width: 36px; height: 36px; border-radius: 50%; border: none; background: rgba(255,255,255,0.15); color: #fff; font-size: 16px; cursor: pointer; display: flex; align-items: center; justify-content: center; }
.img-preview-x:hover { background: rgba(255,255,255,0.3); }
.img-preview-toolbar { position: fixed; left: 50%; bottom: 28px; transform: translateX(-50%); display: flex; align-items: center; gap: 6px; padding: 8px 14px; border-radius: 999px; background: rgba(60,64,72,0.72); }
.img-preview-tool { width: 40px; height: 40px; border: none; background: transparent; color: #fff; font-size: 20px; cursor: pointer; display: flex; align-items: center; justify-content: center; border-radius: 50%; }
.img-preview-tool:hover { background: rgba(255,255,255,0.18); }
</style>
